import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import React from 'react';
import { useSnackbar } from '../../data/SnackbarContext';

const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function CustomSnackbar() {
    const { state, hideSnackbar } = useSnackbar();
    const { isOpen, message, severity } = state;

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        hideSnackbar();
    };

    return (
        <Snackbar open={isOpen} autoHideDuration={5000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={severity}>
                {message}
            </Alert>
        </Snackbar>
    );
}